import { Record } from 'immutable';
import { schema } from 'normalizr';

export const AuthGroup = new Record({
  id: undefined,
  name: undefined,
});

export const authGroupSchema = new schema.Entity('authGroups');

// for reading in nested models, object with { field: schema }
// authGroupSchema.define({  });
